module.exports = __webpack_public_path__ + "img/1_035.b7e545e4.jpg";